import React from "react";
import { Row, Col, Form, Checkbox } from "antd";

import colors from "../../../colors";
import CustomIcon from "../../app/generic/customIcon";

const { Item } = Form;

const Service = ({
  getFieldDecorator,
  infoComponent,
  initialValue,
  fieldName,
  className,
  disabled,
  onChange,
  hideRow,
  warning,
  offset,
  label,
  span,
}) => {
  const item = (
    <Col span={span || 8}>
      {infoComponent}
      <Item wrapperCol={{ offset: offset || 8 }} className={className}>
        {getFieldDecorator(fieldName, {
          initialValue: initialValue ? true : false,
          valuePropName: "checked",
        })(
          <Checkbox onChange={onChange} disabled={disabled}>
            {label}
          </Checkbox>
        )}
        {warning && (
          <CustomIcon
            type="warning"
            marginLeft={10}
            title={warning}
            color={colors.RED}
          />
        )}
      </Item>
    </Col>
  );
  return hideRow ? item : <Row>{item}</Row>;
};

export default Service;
